import { useDispatch, useSelector } from 'react-redux';
import { useUserContext } from '../contexts/UserContext';
import BrowsePlans from './subscriptionComponents/BrowsePlans';
import {
  FreemiumOrOldSubscriptionPlanContainer,
  PurchasedPlan,
} from './subscriptionComponents/PurchasedPlan';
import {
  selectIsBrowsingPlans,
  selectIsUserHaveNotAnyPlan,
  subscriptionActions,
  selectDefaultPaymentMethod,
  selectPlanUpgradedFlag,
  selectUserActivePlanDetails,
  selectUserPlanList,
  selectPlanList,
  selectUserActivePlanSubscriptionOrderId,
  setContactFormDialogOpen,
  selectUserPlanLoading,
  selectUserPlanDetailsLoading,
  selectIsExpiredList,
  selectUserActiveSubscriptionPlanPriceAmount,
  selectIsCreatorPlan,
} from '../redux/slicers/subscriptionSlicer';
import Loader from '../components/Loader/Loader';
import { useEffect, useState } from 'react';
import BillingPayment from './subscriptionComponents/BillingPayment';
import { errorToast, infoToast } from '../helpers/toastHelper';
import {
  UpgradeToNewPlan,
  DowngradeToNewPlan,
  DowngradeMissingFeatureList,
  setClientSubscriptionPlans,
  setMainSubscriptionPlans,
  apiToCancelOrRestoreActiveClientSubscription,
  GetAllCard,
  getSubscriptionPurchasedPacks,
  getPackProductFeatureList,
  setClientSubscriptionPlansV2,
  setFailedClientSubscriptionPlansAndAddOnsV2,
} from '../api/subscription/subscription';
import InfoDialogUI from '../components/InfoDialog/InfoDialogUI';
import PaymentDoneIcon from '../components/icons/PaymentDone';
import Button from '../components/Button';
import { CloseIcon } from '../components/icons/CloseIcon';
import SubscriptionStatusModal from './subscriptionComponents/SubscriptionStatusModal';
import { usePermissionsHandler } from '../hooks/usePermissions';
import { history } from '../history';
import {
  getLocalStorage,
  removeLocalStorage,
  removeUndefinedText,
  wait,
  windowOpen,
} from '../helpers/jsHelper';
import { IS_GAMIFIED_SKIP } from '../constants/projectConstants';
import { gamifyBoardingActions } from '../redux/slicers/gamifySlicer';
import {
  PAYMENT_METHOD_TYPE,
  RECURRING_INTERVAL,
  RECURRING_INTERVAL_INFO,
  filterOutMissingFeatureList,
  getDateFromTimestamp,
} from './subscriptionComponents/subscriptionHelper';
import { PERMISSION, PERMISSIONS } from '../constants/permissionConstants';
import { SETTINGS_TAB } from '../constants/constants';
import { setFailedClientSubscriptionPlansAndAddOns } from '../api/subscription/subscription';
import { HUBSPOT_API } from '../helpers/api';
import { Input } from '../common';
import { FailedSubscriptions } from './subscriptionComponents/FailedSubscriptions';
import { useStripe } from '@stripe/react-stripe-js';
import { PurchasedPacks } from './subscriptionComponents/PurchasedPacks';
import { LogConsole } from '../helpers/logEvents';
import PlanBreadcrumb from './subscriptionComponents/PlanBreadcrumb';
import useCurrentOrganizationInfo from '../hooks/useCurrentOrganizationInfo';
import { CombinePlanAndAddonsPurchase } from './subscriptionComponents/CombinePlanAndAddonsPurchase';
import { userPilotEvents } from '../common/Userpilot/userpilotHelper';
import { getAppState } from '../redux/store';

export const WHY_DOWNGRADING_OPTIONS = {
  BETTER_ALTERNATIVE: "I've found a better alternative",
  SAVE_MONEY: 'I want to save money',
  TEMPORARY: 'I only needed Imagine.io temporarily',
  NOT_RIGHT: "The features weren't right for me",
  OTHER: 'Other',
};

let downgrade = false,
  reviewPlan = false,
  is_texture_plan = null,
  interval = null,
  initialFlag = null,
  upgradePlanInfo = null;

var isPaymentInitiated = false;
let eventFired = false;

export default function Plans({ activeTab, loading = false, faqs = [] }) {
  const dispatch = useDispatch();
  const { isFreemiumOrSelfServeUser, isFreemiumUser, hideNewPlans } = useCurrentOrganizationInfo();
  const {
    currentUser,
    isPremiumUser,
    isPackOrganization,
    isFreemiumOrOldSubscriptionUser,
    updateUserData,
  } = useUserContext();
  const isBrowsingPlan = useSelector(selectIsBrowsingPlans);
  const userHaveNoPlan = useSelector(selectIsUserHaveNotAnyPlan);
  const isHaveExpiredPlan = useSelector(selectIsExpiredList);
  const defaultPaymentMethod = useSelector(selectDefaultPaymentMethod);
  const isBankDefaultPM =
    defaultPaymentMethod?.payment_type?.toLowerCase() === PAYMENT_METHOD_TYPE.US_BANK_ACCOUNT;
  const activePlan = useSelector(selectUserActivePlanDetails);
  // const activePlanOrderId = useSelector(selectUserActivePlanSubscriptionOrderId);
  const activePlanPriceAmount = useSelector(selectUserActiveSubscriptionPlanPriceAmount);
  const isActivePlanCancelAtPeriodEnd = activePlan?.cancel_at_period_end;
  const userPlanLoading = useSelector(selectUserPlanLoading);
  const userPlanDetailsLoading = useSelector(selectUserPlanDetailsLoading);
  const { upgrade: isPlanUpgraded, downgrade: isPlanDowngraded } =
    useSelector(selectPlanUpgradedFlag);
  const getUserPlans = useSelector(selectUserPlanList);
  const userPlans = getUserPlans?.filter((a) => !a.is_cancelled);
  const showBrowsePlans = isBrowsingPlan;
  const showUserPlanDetails = !showBrowsePlans; // && !userHaveNoPlan;
  const showFreemiumOrOldSubscriptionPlanDetails =
    !showBrowsePlans && isFreemiumOrOldSubscriptionUser; // userHaveNoPlan;
  const [upgrade, setUpgrade] = useState(null);
  const [downgradePlan, setDowngradePlan] = useState(null);
  const [planLoading, setPlanLoading] = useState(false);
  const [missingFeature, setMissingFeature] = useState([]);
  const [featureLoading, setFeatureLoading] = useState(false);
  const plans = useSelector(selectPlanList);
  const [packDetailsList, setPackDetailsList] = useState([]);
  const { handlePermissionEvent } = usePermissionsHandler();
  // const [isLoading, setIsLoading] = useState(loading);
  const [modifySubscription, setModifySubscription] = useState(false);

  const stripe = useStripe();

  const [whyDowngrading, setWhyDowngrading] = useState('');
  const [downgradingReason, setDowngradingReason] = useState('');
  const [showWhyDowngradingModal, setShowWhyDowngradingModal] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const wuSelectedPlanId = searchParams.get('selectedPlanId') || '';
  const wuSelectedPlanPriceId = searchParams.get('selectedPlanPriceId') || '';
  const wuSelectedInterval = searchParams.get('selectedInterval') || '';
  const wuSelectedType = searchParams.get('isTextureType') || false;
  const checkout = searchParams.get('checkout') || '';
  const backToReferrerUrl = searchParams.get('referrer') || window.referrer;
  const addons = searchParams.get('addons') === 'true' || false;

  const { trackPageVisitedEvent, trackUserPilotEvent } = userPilotEvents();

  const isPlanTabActive = activeTab === SETTINGS_TAB.PLANS;

  useEffect(() => {
    if (addons && !modifySubscription) { // show addons in case of self serve plan
      setModifySubscription(true);
    }
  }, [addons]);

  useEffect(() => {
    if (addons && !modifySubscription) { // delete addons from url in case of self serve plan
      searchParams.delete('addons');
      history?.replace({
        search: searchParams.toString(),
      });
    }
  }, [modifySubscription]);

  const handleSetState = (value) => {
    initialFlag = { ...value };
  };

  const handleManageFlag = ({ planType, recurringInterval }) => {
    is_texture_plan = planType;
    interval = recurringInterval;
  };

  const handleBackPlanList = (value) => {
    if (wuSelectedPlanId) {
      searchParams.delete('selectedPlanId');
      searchParams.delete('selectedPlanPriceId');
      searchParams.delete('selectedInterval');
      searchParams.delete('isTextureType');
      history?.replace({
        search: searchParams.toString(),
      });
    }
    setUpgrade(null);
  };

  const getPurchasedPacks = async () => {
    setPlanLoading(true);
    try {
      const response = await getSubscriptionPurchasedPacks();
      if (response?.results?.length > 0) {
        const data = await Promise.all(
          response?.results.map(async (a) => ({
            ...a,
            features: !a?.product
              ? []
              : (
                  await getPackProductFeatureList({
                    packProductId: a?.product,
                  })
                )?.results || [],
          }))
        );
        setPackDetailsList(data || []);
      }
    } catch {
      errorToast('An unknown error occured. Please try again.');
      setPackDetailsList([]);
    } finally {
      setPlanLoading(false);
    }
  };

  useEffect(() => {
    trackPageVisitedEvent('My Plan');
  }, []);

  // useEffect(() => {
  //   setIsLoading(userPlanDetailsLoading);
  // }, [userPlanDetailsLoading])

  useEffect(() => {
    if (isPackOrganization) getPurchasedPacks();
  }, [isPackOrganization]);

  useEffect(() => {
    setUpgrade(null);
    modifySubscription && setModifySubscription(false);
    if (isFreemiumOrSelfServeUser) {
      dispatch(subscriptionActions.setPlanDetailsLoading(true));
      dispatch(setClientSubscriptionPlansV2());
      dispatch(setFailedClientSubscriptionPlansAndAddOnsV2());
    }
  }, [currentUser?.organization]);

  const showBrowsePlanScreen = searchParams.get('browsePlan') || false;
  useEffect(() => {
    if (!userPlanDetailsLoading && showBrowsePlanScreen) {
      dispatch(subscriptionActions.setBrowsePlans(true));
    }
  }, [userPlanDetailsLoading, showBrowsePlanScreen]);

  // Old premium case: resetting states to initial as old premium can't buy plan from website or any where else
  const noMainSubscriptionData = getUserPlans?.length === 0;
  useEffect(() => {
    if (userPlanLoading) return;
    if (
      isPremiumUser() &&
      noMainSubscriptionData &&
      !userPlanLoading &&
      wuSelectedPlanId &&
      !userPlanDetailsLoading
    ) {
      downgrade = false;
      reviewPlan = false;
      setDowngradePlan(null);
      setUpgrade(null);

      searchParams.delete('selectedPlanId');
      searchParams.delete('selectedPlanPriceId');
      searchParams.delete('selectedInterval');
      searchParams.delete('isTextureType');
      history.replace({
        search: searchParams.toString(),
      });
    }
  }, [
    activePlan,
    wuSelectedPlanId,
    getUserPlans,
    userPlanLoading,
    isPremiumUser,
    noMainSubscriptionData,
    userPlanDetailsLoading,
  ]);

  useEffect(() => {
    if (!wuSelectedPlanId) return;
    const plan = plans.find((a) => a.id?.toString() === wuSelectedPlanId?.toString());
    if (plan) {
      // const selectedPricing = plan?.pricing_details.filter(
      //   (a) =>
      //     // a?.recurring_interval?.toString() === wuSelectedInterval?.toString() &&
      //     // a?.id?.toString() === wuSelectedPlanPriceId?.toString() &&
      //     (wuSelectedType?.toString === 'true' ? a?.is_textile_plan : !a?.is_textile_plan)
      // );

      let selectedPricing = [];

      if (wuSelectedType === 'true') {
        selectedPricing = plan?.pricing_details.filter((a) => a?.is_textile_plan);
      } else {
        selectedPricing = plan?.pricing_details.filter((a) => !a?.is_textile_plan);
      }

      const _selectedPricing = selectedPricing.find(
        (a) => a?.id?.toString() === wuSelectedPlanPriceId?.toString()
      );

      const selectedOrderId = _selectedPricing?.plan_order;
      const selectedPlanPriceId = _selectedPricing?.id;
      const selectedPlanPriceAmount = +_selectedPricing?.unit_amount;
      const _plan = { ...plan, pricing_details: selectedPricing ? [...selectedPricing] : [] };

      LogConsole('DEBUG___selectedPricing', {
        plans,
        selectedPricing,
        _selectedPricing,
        selectedOrderId,
        selectedPlanPriceId,
        selectedPlanPriceAmount,
        wuSelectedType,
        _plan,
      });

      if (!selectedPlanPriceId) return; // if (!selectedOrderId) return;
      if (selectedPlanPriceAmount === activePlanPriceAmount) {
        // selectedOrderId === activePlanOrderId
        downgrade = false;
        reviewPlan = false;
        setDowngradePlan(null);
        setUpgrade(null);
      } else if (selectedPlanPriceAmount < activePlanPriceAmount) {
        // selectedOrderId < activePlanOrderId
        // dispatch(subscriptionActions.setBrowsePlans(true));
        handleSetState({
          interval: wuSelectedInterval,
          is_texture_plan: wuSelectedType,
        });
        handleManageFlag({
          planType: wuSelectedType || false,
          recurringInterval: wuSelectedInterval,
        });
        setUpgrade(null);
        // const _plan = { ...plan, pricing_details: [selectedPricing] };
        getMissingFeature(_plan);
        setDowngradePlan(_plan);
        downgrade = true;
        reviewPlan = false;
      } else {
        setDowngradePlan(null);
        downgrade = false;
        reviewPlan = false;
        // const _plan = {
        //   ...plan,
        //   pricing_details: plan.pricing_details.filter((a) =>
        //     wuSelectedType === 'true' ? a.is_textile_plan : a.is_default && !a.is_archived
        //   ),
        // };
        setUpgrade(_plan);
        upgradePlanInfo = _plan;
        is_texture_plan = wuSelectedType;
      }
    }
  }, [wuSelectedPlanId, plans, activePlanPriceAmount]);

  useEffect(() => {
    resetManageState();
  }, [showUserPlanDetails]);

  // useEffect(() => {
  //   if (isPlanUpgraded || isPlanDowngraded) {
  // dispatch(setClientSubscriptionPlans());
  //   }
  // }, [isPlanUpgraded, isPlanDowngraded]);

  useEffect(() => {
    if (downgradePlan) {
      getMissingFeature();
    }
  }, [downgradePlan]);

  useEffect(() => {
    if (isPlanTabActive) {
      dispatch(subscriptionActions.setPlanDetailsLoading(true));
      dispatch(GetAllCard());
      dispatch(setClientSubscriptionPlans());
      dispatch(setFailedClientSubscriptionPlansAndAddOns());
    }
  }, [isPlanTabActive]);

  const upgradePlan = async ({ priceData, buttonText, planPriceOrderId, planPriceAmount }) => {
    // fetching the missing features before the downgrade modal shows
    if (activePlanPriceAmount > planPriceAmount) {
      // if (activePlanOrderId > planPriceOrderId) {
      getMissingFeature(priceData);
    }

    console.log('DEBUG____priceData', {
      priceData,
      planPriceAmount,
    });

    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          if (buttonText?.toLocaleLowerCase().includes('review')) {
            reviewPlan = true;
            downgrade = false;
            setUpgrade(priceData);
            upgradePlanInfo = priceData;
          } else if (activePlanPriceAmount > planPriceAmount) {
            // if (activePlanOrderId > planPriceOrderId) {
            setDowngradePlan(priceData);
            downgrade = true;
            reviewPlan = false;
          } else {
            setUpgrade(priceData);
            upgradePlanInfo = priceData;
            reviewPlan = false;
            downgrade = false;
          }
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  const getMissingFeature = async (value = null) => {
    if (featureLoading) return;
    const dplan = value || downgradePlan;
    const intervalData = interval || initialFlag?.interval;
    if (intervalData) {
      const priceId = wuSelectedPlanPriceId
        ? dplan?.pricing_details?.find(
            ({ recurring_interval, id }) =>
              +recurring_interval === +intervalData &&
              id?.toString() === wuSelectedPlanPriceId?.toString()
          )
        : dplan?.pricing_details?.find(
            ({ recurring_interval }) => +recurring_interval === +intervalData
          );
      if (priceId && priceId?.id) {
        setFeatureLoading(true);
        const res = await DowngradeMissingFeatureList(`?downgrade_plan_id=${+priceId?.id}`);
        setFeatureLoading(false);
        setMissingFeature(res?.data || res || []);
      }
    }
  };

  const handleUpgradePlan = (value, type, skipCard) => {
    if (isPaymentInitiated) return;
    isPaymentInitiated = true;
    setShowWhyDowngradingModal(false);

    setPlanLoading(true);

    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          if (defaultPaymentMethod || skipCard) {
            if (reviewPlan) {
              let planDetails = value?.pricing_details?.find(
                ({ recurring_interval, recurring_interval_count }) =>
                  +type === 1
                    ? +recurring_interval === 1 && recurring_interval_count?.toString() === '1' // Monthly
                    : +type === 2
                    ? +recurring_interval === 2 && recurring_interval_count?.toString() === '1' // Yearly
                    : +type === 3
                    ? +recurring_interval === 1 && recurring_interval_count?.toString() === '3' // Quarterly
                    : +type === 4
                    ? +recurring_interval === 1 && recurring_interval_count?.toString() === '6' // Semi annually
                    : null
              );
              if (
                +planDetails?.recurring_interval ===
                +activePlan?.plan_details[0]?.recurring_interval_id
              ) {
                setPlanLoading(false);
                errorToast('The selected plan and active plan both are the same');
              } else {
                if (+planDetails?.recurring_interval === 1) {
                  handleDowngradePlanAPI(value, type);
                } else {
                  handleUpgradePlanAPI(value, type);
                }
              }
            } else {
              if (!downgrade) {
                handleUpgradePlanAPI(value, type);
              } else {
                handleDowngradePlanAPI(value, type);
              }
            }
          } else {
            dispatch(subscriptionActions.setShowCardForm(true));
            setPlanLoading(false);
          }
          isPaymentInitiated = false;
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  const handleUpgradePlanAPI = async (value, type) => {
    const typeValue = type || initialFlag?.interval || 1;
    let planDetails = value?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) =>
        +typeValue === 1
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '1' // Monthly
          : +typeValue === 2
          ? +recurring_interval === 2 && recurring_interval_count?.toString() === '1' // Yearly
          : +typeValue === 3
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '3' // Quarterly
          : +typeValue === 4
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '6' // Semi annually
          : null
    );
    let payload = {
      // organization: currentOrg,
      stripe_price_id: JSON.stringify([{ price: planDetails?.stripe_price_id, quantity: '1' }]),
      paymentMethodId: defaultPaymentMethod?.stripe_payment_method_id,
      collection_method: 'charge_automatically',
      is_upgraded_plan: true,
      recurring_interval: RECURRING_INTERVAL_INFO?.[+typeValue]?.interval,
      recurring_interval_count: RECURRING_INTERVAL_INFO?.[+typeValue]?.count,
      is_texture_plan: is_texture_plan || initialFlag?.isTexturePlan || false,
    };
    if (!userPlans?.length) {
      delete payload.is_upgraded_plan;
    }

    setPlanLoading(true);
    UpgradeToNewPlan(payload)
      .then(async (response) => {
        if (response?.data?.SCA && response?.data?.client_secret) {
          const savedDefaultPM = defaultPaymentMethod?.stripe_payment_method_id;
          const paymentIntentClientSecret = response?.data?.client_secret;

          await stripe
            .confirmPayment({
              clientSecret: paymentIntentClientSecret,
              confirmParams: {
                payment_method: savedDefaultPM,
                return_url: window.location.href,
              },
              redirect: 'if_required',
            })
            .then(({ error, paymentIntent }) => {
              if (error) {
                if (
                  error.param === 'mandate_data' &&
                  error.payment_intent.status === 'processing'
                ) {
                  infoToast('Your payment is currently being processed.');
                } else if (error.payment_intent?.status === 'requires_payment_method') {
                  errorToast(error.message || 'Please add payment method.');
                } else if (error.payment_intent?.status === 'canceled') {
                  // dispatcher(setFailedClientSubscriptionPlansAndAddOns());
                  // dispatcher(setClientSubscriptionPlans());
                  errorToast('Your payment is cancelled.');
                } else {
                  if (error.payment_intent?.status === 'processing') {
                    infoToast('Your payment is currently under processing.');
                  } else {
                    errorToast(error.message || 'Something went wrong. Please try again later.');
                  }
                }
                dispatch(subscriptionActions.PlanUpgraded({ upgrade: false }));
                // closeDialog();
              } else {
                if (paymentIntent?.status === 'succeeded') {
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                } else if (paymentIntent?.status === 'processing') {
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                  infoToast('Your payment is currently under processing.');
                }
              }
            });
        } else {
          dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
        }
      })
      .catch((error) => {
        errorToast(error?.message || 'Something went wrong. Please try again!');
      })
      .finally(() => {
        setPlanLoading(false);
        downgradePlan && setDowngradePlan(null);
      });
  };

  const handleDowngradePlanAPI = async (value, type) => {
    // here, we are restoring active plan while downgrading
    if (isActivePlanCancelAtPeriodEnd && activePlan?.id) {
      await apiToCancelOrRestoreActiveClientSubscription({
        id: activePlan?.id,
        cancel_at_period_end: false,
        successMessage: null,
      })
        .then(() => {})
        .finally(() => {
          dispatch(setClientSubscriptionPlans());
          setPlanLoading(false);
        });
    }

    const typeValue = type || initialFlag?.interval || 1;

    let planDetails = value?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) =>
        +typeValue === 1
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '1' // Monthly
          : +typeValue === 2
          ? +recurring_interval === 2 && recurring_interval_count?.toString() === '1' // Yearly
          : +typeValue === 3
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '3' // Quarterly
          : +typeValue === 4
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '6' // Semi annually
          : null
    );
    const payload = {
      // organization: currentOrg,
      downgraded_plan_id: planDetails?.stripe_price_id,
      is_subscription_schedule: true,
      collection_method: 'charge_automatically',
      paymentMethodId: defaultPaymentMethod?.stripe_payment_method_id,
      // recurring_interval: RECURRING_INTERVAL_INFO?.[+typeValue]?.interval,
      // recurring_interval_count: RECURRING_INTERVAL_INFO?.[+typeValue]?.count,
      is_texture_plan: is_texture_plan || initialFlag?.isTexturePlan || false,
    };
    const res = await dispatch(DowngradeToNewPlan(payload, activePlan?.id));
    if (!res || res) {
      setPlanLoading(false);
      // downgradePlan && setDowngradePlan(null);
    }
  };

  const closeDialog = async () => {
    dispatch(subscriptionActions.setPlanDetailsLoading(true));
    dispatch(setClientSubscriptionPlans());
    dispatch(setFailedClientSubscriptionPlansAndAddOns());
    // setIsLoading(true);
    dispatch(subscriptionActions.setBrowsePlans(false));
    dispatch(subscriptionActions.PlanUpgraded({ upgrade: false, downgrade: false }));
    setUpgrade(null);
    upgradePlanInfo = null;
    setDowngradePlan(null);
    downgrade = false;
    reviewPlan = false;
    setMissingFeature([]);

    updateUserData();

    if (backToReferrerUrl) {
      if (window.referrer) window.referrer = null;
      windowOpen(decodeURI(backToReferrerUrl));
    }

    // setIsLoading(false);

    if (wuSelectedPlanId) {
      searchParams.delete('selectedPlanId');
      searchParams.delete('selectedPlanPriceId');
      searchParams.delete('selectedInterval');
      searchParams.delete('isTextureType');
      history.replace({
        search: searchParams.toString(),
      });
    }

    dispatch(setMainSubscriptionPlans());
    closeDowngradingReasonModal();

    const isGamifiedSkip = getLocalStorage(IS_GAMIFIED_SKIP, true);
    if (isGamifiedSkip) {
      await wait(6000);
      removeLocalStorage(IS_GAMIFIED_SKIP);
      dispatch(gamifyBoardingActions.openGamifiedDialog(true));
    }
  };

  const resetManageState = () => {
    is_texture_plan = null;
    interval = null;
  };

  // useEffect(() => {
  //   LogConsole('DEBUG___downgradePlan', {
  //     downgradePlan,
  //     upgrade,
  //     plans,
  //   });
  // }, [downgradePlan, upgrade, plans]);

  if (userPlanDetailsLoading) return <Loader loading backdrop />;

  const handlePaymentSuccessModal = () => {
    let downgradDetailsPlan = '';
    let downgradPlanName = '';
    const isCreatorPlan = selectIsCreatorPlan(getAppState());
    if (isPlanDowngraded) {
      const _recurringInterval = interval || initialFlag?.interval;
      downgradDetailsPlan = downgradePlan?.pricing_details?.find(
        (a) => a?.recurring_interval === +_recurringInterval
      );
      downgradPlanName = downgradDetailsPlan?.nickname || downgradePlan?.name;
    }

    if (!eventFired) {
      trackUserPilotEvent('Transaction success', {
        plan: 'Creator',
        is_yearly: interval === 2,
        payment_type: isBankDefaultPM ? 'Bank' : 'Card',
      });
      eventFired = true;
    }
    const heading =
      (isPlanUpgraded && (isBankDefaultPM ? 'Payment initiated' : 'Payment successful!')) ||
      (isPlanDowngraded && 'Downgrade successful') ||
      '';
    const activePlanName = upgrade?.name || upgradePlanInfo?.name;
    const expiresOn = getDateFromTimestamp(activePlan?.current_period_end_timestamp, true);
    const description = isCreatorPlan
      ? 'Your plan has been upgraded, and the additional limit have been successfully added to your account.'
      : (isPlanUpgraded && `Your ${activePlanName || ''} plan has been activated.`) ||
        (isPlanDowngraded &&
          `You will be downgraded to ${downgradPlanName} plan on ${expiresOn}.`) ||
        ``;

    if (!heading) return;
    return (
      <SubscriptionStatusModal
        show={true}
        onClose={closeDialog}
        icon={PaymentDoneIcon}
        heading={heading}
        description={description}
        actions={
          <>
            <Button
              color={'primary'}
              variant={'filled'}
              size={'xlg'}
              onClick={closeDialog}
              className={'w-100'}>
              Ok, great
            </Button>
          </>
        }
      />
    );
  };

  const closeDowngradingReasonModal = () => {
    setWhyDowngrading('');
    setDowngradingReason('');
    setShowWhyDowngradingModal(false);
  };

  const openModelForAskingWhyDowngrading = () => {
    const handleWhyDowngrading = (value = '') => {
      const why_downgrading = value || downgradingReason || '';
      if (!why_downgrading) return;
      const contactObj = {
        properties: {
          email: currentUser?.user?.email,
          firstname: currentUser?.user?.first_name,
          lastname: removeUndefinedText(currentUser?.user?.last_name),
          why_downgrading: why_downgrading,
        },
      };

      fetch(HUBSPOT_API, {
        method: 'POST',
        body: JSON.stringify(contactObj),
      })
        .then((response) => {
          if (response.ok) {
            handleUpgradePlan(downgradePlan, interval, true);
            return response.json();
          }
          closeDowngradingReasonModal();
          throw new Error('Unable to submit your feedback.');
        })
        .catch(() => {
          errorToast('Unable to submit your feedback.');
          closeDowngradingReasonModal();
        });
    };

    return (
      <InfoDialogUI size="lg" show={true} title="" onClose={closeDowngradingReasonModal}>
        <div>
          <h3
            style={{
              margin: '0 0 8px',
              fontWeight: 400,
              fontSize: '24px',
              lineHeight: '120%',
              textAlign: 'center',
              letterSpacing: '0.01em',
              color: '#202020',
            }}>
            {currentUser?.user?.name}, we’re sorry you’re thinking of downgrading. Would you tell us
            why? We might be able to help.
          </h3>

          <ul
            className="d-flex flex-column gap-1"
            style={{
              margin: '24px 0 0',
              padding: 0,
              listStyle: 'none',
            }}>
            {Object.keys(WHY_DOWNGRADING_OPTIONS).map((key, i) => {
              const isSelected = whyDowngrading?.toLowerCase() === key?.toLowerCase();
              return (
                <li
                  key={i}
                  onClick={() => {
                    setWhyDowngrading(key);
                    if (key?.toLowerCase() !== WHY_DOWNGRADING_OPTIONS.OTHER?.toLowerCase())
                      handleWhyDowngrading(WHY_DOWNGRADING_OPTIONS[key]);
                  }}
                  style={{
                    cursor: 'pointer',
                    padding: '16px 24px',
                    color: isSelected ? '#fff' : '#202020',
                    fontSize: '15px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '120%',
                    letterSpacing: '0.15px',
                    backgroundColor: isSelected ? 'var(--primary-color)' : '#eee',
                  }}>
                  {WHY_DOWNGRADING_OPTIONS[key]}
                </li>
              );
            })}
            {whyDowngrading?.toLowerCase() === 'other' && (
              <li
                style={{
                  padding: '12px 0 0',
                }}>
                <Input
                  label={false}
                  className={`w-100 my-details-input`} // ${error ? 'input-error' : ''}`}
                  name="text"
                  title="Reason"
                  maskPlaceholder={'Reason for downgrading...'}
                  onChange={(v) => setDowngradingReason(v.value)}
                  required
                  value={downgradingReason}
                  style={{
                    boxShadow: 'none',
                  }}
                  onKeyDown={(e) => {
                    if (e.key !== 'Enter') return;
                    handleWhyDowngrading?.(e.value);
                  }}
                />
              </li>
            )}
          </ul>
        </div>
      </InfoDialogUI>
    );
  };

  const handleDowngradeBeforeModal = () => {
    const list = filterOutMissingFeatureList(missingFeature);
    return (
      <InfoDialogUI size="lg" show={true} title="" onClose={closeDialog}>
        <div>
          <h3
            style={{
              margin: '0 0 8px',
              fontWeight: 700,
              fontSize: '24px',
              lineHeight: '120%',
              textAlign: 'center',
              letterSpacing: '0.01em',
              color: '#202020',
            }}>
            Before you go, {currentUser?.user?.name}
          </h3>
          {list && list?.length > 0 ? (
            <>
              <p
                style={{
                  margin: '0 0 24px',
                  fontWeight: 500,
                  fontSize: '15px',
                  lineHeight: '120%',
                  textAlign: 'center',
                  letterSpacing: '0.01em',
                  color: '#202020',
                }}>
                By downgrading to {downgradePlan?.name}, your team will loose access to the
                following:
              </p>
              <div className="ms-5" style={{ margin: '0 0 20px' }}>
                {list?.map((list, index) => {
                  return (
                    <p
                      className="d-flex align-items-center gap-2"
                      style={{
                        margin: '0 0 4px',
                        fontWeight: '500',
                        fontSize: '15px',
                        lineHeight: '120%',
                        letterSpacing: '0.01em',
                        color: '#202020',
                      }}
                      key={index}>
                      {' '}
                      <CloseIcon style={{ width: 12, height: 12 }} />{' '}
                      {list?.product_name || list?.name} (
                      {(list?.missing_quantity &&
                        list?.missing_quantity?.toString()?.replace('-', '')) ||
                        0}
                      )
                    </p>
                  );
                })}
              </div>
            </>
          ) : (
            <p
              style={{
                margin: '0 0 24px',
                fontWeight: 500,
                fontSize: '15px',
                lineHeight: '120%',
                textAlign: 'center',
                letterSpacing: '0.01em',
                color: '#202020',
              }}>
              Are you sure you wan to downgrade to {downgradePlan?.name?.replace('Plan', '')} plan?
            </p>
          )}

          <Button size="xlg" className="w-100" onClick={closeDialog}>
            <span className="text-white">I changed my mind, take me back</span>
          </Button>

          <hr style={{ margin: '2rem auto', background: '#000' }} />

          <div className="downgradeModelActionBtn">
            <div className="w-100">
              <p
                style={{
                  margin: '0 0 12px',
                  fontWeight: 500,
                  fontSize: '15px',
                  lineHeight: '120%',
                  textAlign: 'center',
                  letterSpacing: '0.01em',
                  color: '#202020',
                }}>
                Have a question?
              </p>
              <Button size="xlg" className="flex-fill w-100" onClick={contactSupport}>
                <span className="text-white">Contact support</span>
              </Button>
            </div>
            <div className="w-100">
              <Button
                size="xlg"
                className="flex-fill w-100"
                style={{
                  color: 'var(--dark-color)',
                  background: '#CACACA',
                  borderColor: '#CACACA',
                }}
                loading={planLoading}
                onClick={() => {
                  // handleUpgradePlan(downgradePlan, interval, true);
                  setShowWhyDowngradingModal(true);
                }}>
                I still want to downgrade
              </Button>
            </div>
          </div>
        </div>
      </InfoDialogUI>
    );
  };

  const contactSupport = () => {
    downgrade = false;
    reviewPlan = false;
    setDowngradePlan(null);
    dispatch(setContactFormDialogOpen(true));
  };

  const goBack = () => {
    if (showBrowsePlanScreen) {
      searchParams.delete('browsePlan');
      history.replace({
        search: searchParams.toString(),
      });
    }
    dispatch(subscriptionActions.setBrowsePlans(false));
  };

  return (
    <>
      {showWhyDowngradingModal && openModelForAskingWhyDowngrading()}
      {(isPlanUpgraded || isPlanDowngraded) && handlePaymentSuccessModal()}
      {downgradePlan && !isPlanDowngraded && handleDowngradeBeforeModal()}
      {upgrade && !isFreemiumOrSelfServeUser ? (
        <BillingPayment
          downgrade={downgrade}
          back={handleBackPlanList}
          loading={planLoading}
          planDetails={upgrade}
          handleUpgradePlan={handleUpgradePlan}
          reviewPlan={reviewPlan}
          interval={interval}
          isTexturePlan={is_texture_plan}
          recurringInterval={Number(wuSelectedInterval)}
          initialFlag={initialFlag}
        />
      ) : (
        <>
          {!modifySubscription && <FailedSubscriptions />}
          {!modifySubscription &&
            showFreemiumOrOldSubscriptionPlanDetails &&
            userHaveNoPlan &&
            !isHaveExpiredPlan && (
              <FreemiumOrOldSubscriptionPlanContainer
                setModifySubscription={setModifySubscription}
              />
            )}
          {!modifySubscription && showUserPlanDetails && (
            <PurchasedPlan
              userHaveNoPlan={userHaveNoPlan}
              setModifySubscription={setModifySubscription}
            />
          )}
          {modifySubscription && (
            <PlanBreadcrumb
              hideError
              goBack={() => setModifySubscription(false)}
              hideBack={false}
              stickyHeader={true}
              goBackText={
                <p className="mb-0">
                  My Plans{' '}
                  <span style={{ fontSize: '15px', color: '#00000073' }}>
                    / Manage Subscription
                  </span>
                </p>
              }
            />
          )}

          {isFreemiumOrSelfServeUser && !hideNewPlans && (
            <>
              {(isFreemiumUser ||
                userHaveNoPlan ||
                modifySubscription ||
                wuSelectedPlanId ||
                checkout) && (
                <CombinePlanAndAddonsPurchase
                  setModifySubscription={setModifySubscription}
                  {...{
                    modifySubscription,
                    wuSelectedPlanId,
                    wuSelectedPlanPriceId,
                    wuSelectedInterval,
                    setPlanLoading,
                  }}
                />
              )}
            </>
          )}

          {/* {isFreemiumOrSelfServeUser && hideNewPlans && (
            <>
              {(isFreemiumUser ||
                userHaveNoPlan ||
                modifySubscription ||
                wuSelectedPlanId ||
                checkout) && (
                <CombinePlanAndAddonsPurchase
                  setModifySubscription={setModifySubscription}
                  showLimitedAddons={true}
                  {...{
                    modifySubscription,
                    wuSelectedPlanId,
                    wuSelectedPlanPriceId,
                    wuSelectedInterval,
                    setPlanLoading,
                  }}
                />
              )}
            </>
          )} */}

          {!modifySubscription && isPackOrganization && !showBrowsePlans && (
            <PurchasedPacks list={packDetailsList} loading={planLoading} />
          )}

          {showBrowsePlans && !modifySubscription && (
            <BrowsePlans
              hideBreadcrumb={false}
              upgradeToSelectedPlan={upgradePlan}
              handleManageFlag={handleManageFlag}
              goBack={goBack}
              handleSetState={handleSetState}
              isPackUser={isPackOrganization}
              faqs={faqs}
              // interval={interval}
              // isTexturePlan={is_texture_plan}
            />
          )}
        </>
      )}
    </>
  );
}
